/**
 * Legacy structural reference: components/welcome/url/icons.tsx — the `Icon`
 * styled wrapper (30x30, rounded circle, `margin-left: 8px`) around a GIPHY
 * SVG and two `ss-social` icon-font glyphs.
 *
 * `GiphyIcon`'s SVG is copied verbatim from legacy. The `ss-social` icon font
 * isn't part of the Next build, so `YoutubeIcon`/`VimeoIcon` are redrawn as
 * inline SVG glyphs instead of installing that font for two characters — no
 * same visual role (a small brand mark in a colored circle), no new
 * dependency. Not part of any measured acceptance box (docs/plans/2026-08-07-001-
 * creation-welcome-measurements.md §6 only measures the input wrapper as a
 * whole), so there's no pixel target to match here.
 */
const wrapperClassName = 'ml-2 flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full text-white'

export const GiphyIcon = () => (
    <div data-platform-icon="giphy" className={wrapperClassName} style={{ backgroundColor: '#000' }}>
        <svg width="13" height="16" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path d="M10.811 5.333h1.802v8.89h-1.802z" fill="#93F" />
                <path d="M0 14.222h12.613V16H0z" fill="#0CF" />
                <path d="M0 1.778h1.802v12.444H0z" fill="#0F9" />
                <path d="M0 0h7.207v1.778H0z" fill="#FFF35C" />
                <path d="M10.811 3.556V1.778H9.01V0H7.207v5.334H12.613V3.555z" fill="#F66" />
                <path d="M7.207 0v1.778H5.406zM10.811 7.129V5.333h1.802z" fill="#0F0F0F" opacity=".4" />
            </g>
        </svg>
    </div>
)

export const YoutubeIcon = () => (
    // Triangle spans x 4.5..11.5 and y 4..12, so it is centred on its bounding
    // box and fills the disc. The previous 4.5x5.5 arrowhead (x 6.5..11) was
    // centred on the triangle's centroid, which is the usual choice for a
    // standalone play button but at 30px left it looking small and pushed
    // right inside the circle.
    <div data-platform-icon="youtube" className={`${wrapperClassName} bg-giphyRed`}>
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.5 4v8l7-4z" fill="#fff" />
        </svg>
    </div>
)

export const VimeoIcon = () => (
    // Vimeo's own mark on a 24 viewBox. The previous hand-drawn path was
    // sheared and ran off to the right of the disc, which read as a bird
    // rather than a "v" at 30px.
    <div data-platform-icon="vimeo" className={`${wrapperClassName} bg-giphyBlue`}>
        <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.98 6.19c-.11 2.34-1.74 5.55-4.9 9.62-3.26 4.25-6.02 6.38-8.28 6.38-1.4 0-2.58-1.29-3.55-3.87l-1.93-7.1c-.72-2.59-1.49-3.88-2.31-3.88-.18 0-.81.38-1.88 1.13L0 6.99c1.2-1.05 2.38-2.1 3.54-3.16 1.6-1.38 2.8-2.1 3.6-2.18 1.9-.18 3.06 1.11 3.5 3.88.47 2.99.8 4.85.98 5.58.54 2.47 1.14 3.7 1.79 3.7.5 0 1.27-.8 2.29-2.4 1.01-1.6 1.56-2.81 1.63-3.65.14-1.35-.38-2.03-1.57-2.03-.56 0-1.15.13-1.75.39 1.16-3.83 3.39-5.69 6.67-5.58 2.44.07 3.58 1.65 3.44 4.75z"
                fill="#fff"
            />
        </svg>
    </div>
)
